import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { RetailApplicationModel } from "../../../components/Model/RetailApplicationModel";
import { AuthService, EventApplicationRetailService } from "../../../services";
import { TraderUnitService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";
import { toast } from "react-toastify";

const RetailStandDescription = ({ eventId, appId, pitchId }) => {
  const [retailApplicationData, setRetailApplicationData] = useState({
    ...RetailApplicationModel,
  });
  const [isRetailStand, setIsRetailStand] = useState(true);
  const loginUser = AuthService.getLoginUser();
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();
  const setRetailInitialValue = () => {
    retailApplicationData.eventId = eventId;
    retailApplicationData.traderId = loginUser?.id;
    retailApplicationData.appId = appId;
    retailApplicationData.pitchId = pitchId;
    setRetailApplicationData(retailApplicationData);
  };
  const getRetailApplicationDetails = async () => {
    try {
      const userId = loginUser?.id;

      const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit();
      const res = await EventApplicationRetailService.getRetailApplicationByPitchAndUserId(
        pitchId,
        userId,
        selectedTraderUnit?.id
      );
      if (res?.isSuccess) {
        const retailApplicationFormMappedData = {
          ...retailApplicationData,
          ...res?.data,
        };
        retailApplicationFormMappedData.pitchId = pitchId;
        retailApplicationFormMappedData.describesyourstand === "Charity"
          ? setIsRetailStand(false)
          : setIsRetailStand(true);
        setValue("retailApplicationFormData", retailApplicationFormMappedData);
      } else {
        setRetailInitialValue();
        setValue("retailApplicationFormData", retailApplicationData);
      }
    } catch (error) {
      handleConsoleError(error);
     // toast.error(error?.message|| message);
      setRetailInitialValue();
      setValue("retailApplicationFormData", retailApplicationData);
    }
  };
  useEffect(() => {
    register("");
    getRetailApplicationDetails();
  }, []);
  return (
    <React.Fragment>
      <div role="tabpanel" className="tab-pane" id="Submit">
        <h2 className="retail-form-hd1">Stand Description</h2>
        <div role="tabpanel" className="tab-pane active" id="Ideate">
          <Form.Control
            type="hidden"
            defaultValue={retailApplicationData?.eventId}
            {...register("retailApplicationFormData.eventId")}
          />
          <Form.Control
            type="hidden"
            defaultValue={retailApplicationData?.appId}
            {...register("retailApplicationFormData.appId")}
          />
          <Form.Control
            type="hidden"
            defaultValue={loginUser?.id}
            {...register("retailApplicationFormData.traderId")}
          />

          <div className="trader-booking-f">
            <h3>
              On Site Contact Number <span className="text-danger">*</span>
            </h3>
            <Form.Control
              className="effect-4"
              placeholder="Enter your contact number"
              maxLength={15}
              type="text"
              {...register("retailApplicationFormData.onSiteContact", {
                required: "Contact number is required",
                pattern: {
                  value: /^[0-9]\d{8,14}$/,
                  message: "Invalid contact number",
                },
              })}
              defaultValue={retailApplicationData?.onSiteContact}
            />
            <span className="focus-border"></span>
          </div>
          {errors.retailApplicationFormData?.onSiteContact && (
            <span className="text-danger">
              {errors.retailApplicationFormData.onSiteContact?.message}
            </span>
          )}
          <div className="trader-booking-f">
            <h3>
              Please select which of the following best describes your stand{" "}
              <span className="text-danger">*</span>
            </h3>
            <div className="form-group">
              <label>
                <input
                  type="radio"
                  value="Retail / Merchandise"
                  {...register("retailApplicationFormData.describesyourstand", {
                    required: "Please select an option",
                  })}
                  defaultChecked={
                    watch("retailApplicationFormData.describesyourstand") ===
                    "Retail / Merchandise"
                  }
                  onChange={() => setIsRetailStand(true)}
                />{" "}
                Retail / Merchandise
              </label>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="radio"
                  value="Charity"
                  {...register("retailApplicationFormData.describesyourstand", {
                    required: "Please select an option",
                  })}
                  defaultChecked={
                    watch("retailApplicationFormData.describesyourstand") ===
                    "Charity"
                  }
                  onChange={() => setIsRetailStand(false)}
                />{" "}
                Charity
              </label>
            </div>
            {errors.retailApplicationFormData?.describesyourstand && (
              <span className="text-danger">
                {errors.retailApplicationFormData.describesyourstand?.message}
              </span>
            )}

            {isRetailStand && (
              <div className="itam-board1">
                <div className="trader-booking-f">
                  <h3>
                    Description of items to be sold{" "}
                    <span className="text-danger">*</span>
                  </h3>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    {...register("retailApplicationFormData.itemstobesold", {
                      required: "Description is required",
                    })}
                    maxLength={500}
                    defaultValue={retailApplicationData?.itemstobesold}
                  />
                  <span className="focus-border"></span>
                </div>
                {errors.retailApplicationFormData?.itemstobesold && (
                  <span className="text-danger">
                    {errors.retailApplicationFormData.itemstobesold?.message}
                  </span>
                )}
                <span className="focus-border"></span>
              </div>
            )}
            {!isRetailStand && (
              <div>
                <div className="trader-booking-f">
                  <h3>
                    Please enter your registered charity name{" "}
                    <span className="text-danger">*</span>
                  </h3>
                  <Form.Control
                    className="effect-4"
                    placeholder="Enter charity name"
                    maxLength={100}
                    type="text"
                    {...register("retailApplicationFormData.charityName", {
                      required: "Charity name is required",
                    })}
                    defaultValue={retailApplicationData?.charityName}
                  />
                  <span className="focus-border"></span>
                </div>
                {errors.retailApplicationFormData?.charityName && (
                  <span className="text-danger">
                    {errors.retailApplicationFormData?.charityName?.message}
                  </span>
                )}
                <span className="focus-border"></span>
                <div className="trader-booking-f">
                  <h3>
                    Please enter your registered charity number{" "}
                    <span className="text-danger">*</span>
                  </h3>
                  <Form.Control
                    className="effect-4"
                    placeholder="Enter charity number"
                    maxLength={15}
                    type="text"
                    {...register("retailApplicationFormData.charityNumber", {
                      required: "Charity number is required",
                      pattern: {
                        value: /^[0-9]\d{8,14}$/,
                        message: "Invalid number",
                      },
                    })}
                    defaultValue={retailApplicationData?.charityNumber}
                  />
                  <span className="focus-border"></span>
                </div>
                {errors.retailApplicationFormData?.charityNumber && (
                  <span className="text-danger">
                    {errors.retailApplicationFormData?.charityNumber?.message}
                  </span>
                )}
                <span className="focus-border"></span>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RetailStandDescription;
